<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">

          <div class="panel-body" v-if="!form.data.id">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form class="form-inline search-fields" @submit.prevent="form.onSiteSearch('adultSurveillanceId')">
                  <div class="form-group">
                    <select class="form-control" id="searchField" name="searchField" v-model="form.siteSearch.field">
                      <option value="sample">Sample #</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input type="search" placeholder="search sites" class="form-control" v-model="form.siteSearch.term">
                    <span class="input-group-addon pointer" v-on:click="form.onSiteSearch('adultSurveillanceId')" title="search"><i class="fa fa-search"></i></span>
                  </div>
                  <i class="fa fa-spinner fa-spin" v-if="siteSearch.loading"></i>
                </form>
              </div>
            </div>
          </div>

          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div v-if="!form.data.id" class="form-group" :class="{'has-error': form.errors.has('adultSurveillanceId') }">
              <label class="control-label">Sample Number</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.adultSurveillanceId" v-on:change="setSelected">
                  <option v-for="item in siteSearch.sites" v-bind:value="item.id">{{item.attributes.sampleNumber}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('adultSurveillanceId')" v-text="form.errors.get('adultSurveillanceId')"></span>
            </div>

            <div v-if="!form.data.id && siteSearch.selected.trapSite" class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-5 col-sm-offset-1"><strong>Mosquito Species:</strong> {{ mosquitoName(siteSearch.selected.mosquitoSpeciesId) }}</div>
                <div class="col-xs-12 col-sm-5"><strong>Trap Number:</strong> {{ siteSearch.selected.trapSite.trapNumber }}</div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-5 col-sm-offset-1"><strong>Mosquito Count:</strong> {{ siteSearch.selected.mosquitoCount }}</div>
                <div class="col-xs-12 col-sm-5"><strong>Trap Location:</strong>
                  {{ siteSearch.selected.trapSite.address }},
                  {{ siteSearch.selected.trapSite.city }}, {{ stateName(siteSearch.selected.trapSite.stateId) }}, {{ siteSearch.selected.trapSite.zip }}
                </div>
              </div>
            </div>


            <div v-if="form.data.id">
              <div class="form-group" :class="{'has-error': form.errors.has('sampleNumber') }">
                <label class="control-label">Sample No.</label>
                <input type="text" class="form-control" id="sampleNumber" v-model="form.data.sampleNumber" readonly>
                <span class="help-block" v-if="form.errors.has('sampleNumber')" v-text="form.errors.get('sampleNumber')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('trapNumber') }">
                <label class="control-label">Trap Number</label>
                <input type="text" class="form-control" id="trapNumber" v-model="form.data.trap.number" readonly>
                <span class="help-block" v-if="form.errors.has('trapNumber')" v-text="form.errors.get('trapNumber')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('trapLocation') }">
                <label class="control-label">Trap Location</label>
                <input type="text" class="form-control" id="trapLocation" v-model="address" readonly>
                <span class="help-block" v-if="form.errors.has('trapLocation')" v-text="form.errors.get('trapLocation')"></span>
              </div>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('dateTested') }">
              <label class="control-label">Date Tested</label>
              <date-picker v-model="form.data.dateTested"></date-picker>
              <span class="help-block" v-if="form.errors.has('dateTested')" v-text="form.errors.get('dateTested')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('performedBy') }">
              <label class="control-label">Performed By <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="performedBy" v-model="form.data.performedBy">
              <span class="help-block" v-if="form.errors.has('performedBy')" v-text="form.errors.get('performedBy')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('poolNumber') }">
              <label class="control-label">Pool No.</label>
              <input type="text" class="form-control" id="poolNumber" v-model="form.data.poolNumber">
              <span class="help-block" v-if="form.errors.has('poolNumber')" v-text="form.errors.get('poolNumber')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('poolSize') }">
              <label class="control-label">Pool Size <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="poolSize" v-model="form.data.poolSize">
              <span class="help-block" v-if="form.errors.has('poolSize')" v-text="form.errors.get('poolSize')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('assayId') }">
              <label class="control-label">Assay Type <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.assayId">
                  <option></option>
                  <option v-for="item in assays" v-bind:value="item.id">{{item.attributes.assay}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('assayId')" v-text="form.errors.get('assayId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('resultId') }">
              <label class="control-label">Result</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.resultId">
                  <option></option>
                  <option v-for="item in results" v-bind:value="item.id">{{item.attributes.result}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('resultId')" v-text="form.errors.get('resultId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('workStatus') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('workStatus')" v-text="form.errors.get('workStatus')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';

  export default {
    name: 'assay-form',

    props: ['form'],

    data() {
      return {
        siteSearch: this.$store.getters.siteSearch
      }
    },

    components: {
      LoadingButton,
      DatePicker,
    },

    computed: {
      assays() {
        return this.$store.getters.assays;
      },
      results() {
        return this.$store.getters.results;
      },
      address() {
        return `${this.form.data.trap.address}, ${this.form.data.trap.city}, ${this.stateName(this.form.data.trap.stateId)} ${this.form.data.trap.zip}`;
      },
      workStatus() {
        return this.$store.getters.workStatus;
      },
    },

    methods: {
      mosquitoName(id) {
        return this.$store.getters.mosquitoNameById(id);
      },
      setSelected() {
        this.$store.dispatch('setSiteSearchSelected', this.form.data.adultSurveillanceId);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      }
    },

    mounted() {
      this.form.siteSearch.field = 'sample';
    }

  }

</script>